<template>
	<figure
		v-if="hasURL || loading"
		v-skeleton="{
			loading,
			sizes: {
				Small: { width: '2rem', height: '2rem' }
			}
		}"
		:class="
			[
				'OrganisationLogo',
				{
					hasImage: hasURL && !loading,
					large: large,
				}
			]"
	>
		<img
			v-if="hasURL"
			:src="imageUrl"
			:alt="`Logo of ${organisationName}`"
			loading="lazy"
		/>
	</figure>
</template>


<script setup lang="ts">
import { computed } from 'vue';

const props = defineProps({
	imageUrl: {
		type: String,
		required: false,
	},
	organisationName: {
		type: String,
		required: true,
	},
	loading: {
		type: Boolean,
		default: true,
	},
	large: {
		type: Boolean,
		default: false,
	},
});

const hasURL = computed(() => !!props.imageUrl && props.imageUrl.length > 0);
</script>

<style scoped lang="scss">
	.OrganisationLogo {
		display: flex;
		justify-content: center;
		align-items: center;
		border-radius: 0.25rem;
		border: 0.125rem solid $Grey-200;
		width: 2.25rem;
		height: 2.25rem;

		@include Breakpoint(Large, ExtraLarge) {
			width: 2.5rem;
			height: 2.5rem;
		}

		@include PaddingAreas(0.25);
		@include MarginAreas(0);

		&.large {
			width: 2.25rem;
			height: 2.25rem;

			@include Breakpoint(Large, ExtraLarge) {
				width: 3.25rem;
				height: 3.25rem;
			}

			img {
				//important === galactus
				width: 2.5rem !important;
				height: 2.5rem !important;

				@include Breakpoint(Large, ExtraLarge) {
					width: 3.75rem !important;
					height: 3.75rem !important;
				}
			}
		}

		&.hasImage {
			background: $White;
		}

		img {
			//important === galactus
			width: 2.25rem !important;
			height: 2.25rem !important;
			border-radius: 0.125rem;
			max-width: unset !important;

			@include Breakpoint(Large, ExtraLarge) {
				width: 2.5rem !important;
				height: 2.5rem !important;
			}
		}

		i.lnr-university {
			font-size: 2.25rem;
			color: $Grey-900;
			opacity: .1;

			@include Breakpoint(Large, ExtraLarge) {
				font-size: 2.5rem;
			}
		}
	}
</style>
